/**
 * Static constant rules about the app
 */

/*
 * Default pixel value width of the map screen canvas
 */
export const MAP_WIDTH = 1560;

/*
 * Default pixel value height of the map screen canvas
 */
export const MAP_HEIGHT = 1080;
